import {
  AppSidebar,
  NavigationContext,
  useAppSidebar,
  useTanStackRouterAdapter,
} from '@autone/ui-next/components';
import { experimentalStyled as styled } from '@mui/material/styles';
import { Outlet } from '@tanstack/react-router';

export * from './AssortmentLayout';

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
});

const DashboardSidebar = () => {
  const { config, userCardConfig, userProfile, globalDataFreshness } =
    useAppSidebar();
  return (
    <AppSidebar
      config={config}
      userCardConfig={userCardConfig}
      profile={userProfile}
      globalDataFreshness={globalDataFreshness}
    />
  );
};

export function DashboardLayout() {
  const routingAdapter = useTanStackRouterAdapter();
  return (
    <RootStyle>
      <NavigationContext adapter={routingAdapter}>
        <DashboardSidebar />
      </NavigationContext>
      <div className="h-screen overflow-y-auto w-full" id={'dashboard-layout'}>
        <Outlet />
      </div>
    </RootStyle>
  );
}
